import types from '../../types';

const profit = (state = { loading: true, data: null }, { type, payload }) => {
  switch (type) {
    case types.GET_PROFIT_START:
      return { ...state, loading: true };

    case types.GET_PROFIT_SUCCESS:
      return { data: payload, loading: false };

    case types.GET_PROFIT_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default profit;
